import { writeGeneratedFile } from "../../helpers/fs";
import logger from "../../helpers/logger";
import { generateFileHeader } from "./fileHeader";

const FILE_NAME = "object.ts";

export function generateObjectTypes(outputDir: string): void {
  logger.debug(`Generating object types file: ${FILE_NAME}`);

  const objectContent = `
${generateFileHeader(FILE_NAME)}

export interface AttioObject {
  id: {
    workspace_id: string;
    object_id: string;
  };
  api_slug: string;
  singular_noun: string;
  plural_noun: string;
  created_at: string;
  updated_at: string | null;
}
`;

  writeGeneratedFile(outputDir, FILE_NAME, objectContent);
}
